import { ChallengeLargeClassification } from '@/domain/entities/problem/challengeLargeClassification'
import { Contest } from '@/domain/entities/problem/contest'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export class GetChallengeUseCase {
  constructor(private repository: ProblemRepository) {}

  async getChallengeList(displayLanguage: DisplayLanguageType): Promise<ChallengeLargeClassification[]> {
    try {
      const data = await this.repository.getChallengeList(displayLanguage)
      return data
    } catch (error) {
      console.error(`Error in GetChallengeUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getChallengeById(
    displayLanguage: DisplayLanguageType,
    challengeLargeClasificationId: string,
    challengeMiddleClasificationId: string
  ): Promise<Contest[]> {
    try {
      const data = await this.repository.getChallengeById(
        displayLanguage,
        challengeLargeClasificationId,
        challengeMiddleClasificationId
      )
      return data
    } catch (error) {
      console.error(`Error in GetChallengeUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
